import React, { useState } from "react";
import { ModalThemMoiVaSua } from "./ModalThemMoiVaSua";

export const BtnSua = ({ item, onReload }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSaveSuccess = () => {
        setShow(false);
        if (onReload) onReload();
    };
    const editData = { CustomerId: item.CustomerId };

    return (
        <>
            <button
                type="button"
                className="btn btn-border-new"
                onClick={handleShow}
                title="Sửa"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    border: 'none',
                    padding: 0,
                    backgroundColor: 'transparent',
                    cursor: 'pointer'
                }}
            >
                <img
                    src="/app-assets/images/icon-edit-v2.png"
                    title="Sửa"
                    style={{ width: '22px', height: 'auto', display: 'block' }}
                />
                <span style={{
                    color: 'rgb(43, 51, 94)',
                    fontSize: '16px',
                    lineHeight: '1',
                    marginTop: '2px',
                }}>
                    Sửa
                </span>
            </button>
            {show && (
                <ModalThemMoiVaSua
                    show={show}
                    onHide={handleClose}
                    editData={editData}
                    dbName={item.DBName}
                    onSearch={handleSaveSuccess}
                />
            )}
        </>
    );
};